package com.solevo.dist.application.models

import kotlinx.serialization.Serializable

@Serializable
data class AnswerQuoteRequest(
    val legalEntityId: String? = User.legalId,
    val customerId: String? = User.currentCustomerId.value,
    val contactId: String? = User.userContactId,
    val quoteId: String? = null,
    val orderReference: String? = null,
)